module.exports = __webpack_public_path__ + "static/def2_jaune-0e674163cb9cacbcd2edcf9565180a61.jpg";